<template>
  <div :class="`tab-menu ${tabStyle}`">
    <ul class="unstyle inline">
      <li v-for="menu in menusFiltered" :key="menu.name" class="vertical-middle">
        <slot v-if="isCustom" :item="menu" name="custom-menu"/>
        <component
          v-else
          :is="linkTag"
          :to="{ path: menu.href, query: menu.query }"
          :class="getTabClass(menu)"
          :exact="menu.href === '/' || menu.exact"
          :data-qa="$fn.formatDataQa(menu.name, 'tab')"
        >
          <slot
            v-if="isCustomIcon"
            :item="menu"
            :isActive="checkActive(menu)"
            name="custom-icon"
          />
          <span
            v-if="!isHideName || (alwaysShowActiveName && checkActive(menu))"
            :data-qa="$fn.formatDataQa(menu.name, 'txt-tab')"
            class="text-menu"
          >
            {{ menu.isTranslate ? $t(menu.type || menu.name) : (menu.type || menu.name) }}
          </span>
          <CncBadgeNumber
            v-if="menu.count"
            class="tab-badge"
            :number="menu.count"
            size="medium"
            :data-qa="$fn.formatDataQa(menu.name, 'txt-tab', 'amount')"
          />
        </component>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    menus: { type: Array, required: true },
    tabStyle: { type: String, default: 'line' },
    tabClass: { type: String, default: '' },
    isCustom: { type: Boolean },
    isCustomIcon: { type: Boolean },
    isHideName: { type: Boolean },
    alwaysShowActiveName: { type: Boolean }
  },
  data () {
    return {
      linkTag: this.$store.state.framework === 'vue' ? 'router-link' : 'NLink'
    }
  },
  computed: {
    menusFiltered () {
      return this.menus.filter(e => !e.hide)
    }
  },
  mounted () {
    this.$nextTick(() => this.$store.dispatch('initMouseSwipe', { wrapper: '.tab-menu', context: this }))
  },
  methods: {
    checkRoute (menu) {
      const samePath = menu.active && menu.active.some(e => (menu.routePath || this.$route.path).includes(e))
      const exact = menu.exact && menu.href.replace(/\/$/, '') === (menu.routePath || this.$route.path).replace(/\/$/, '')
      const childPath = !menu.exact && menu.isCheckChild ? this.$route.path.includes(menu.href) : false
      const childDynamic = menu.forceActive || false
      return samePath || exact || childPath || childDynamic
    },
    checkQuery (menu) {
      if (this.queryActive) menu.query = this.currentTab.query
      else return true
    },
    getTabClass (menu) {
      const isActive = this.checkRoute(menu) && this.checkQuery(menu)
      return `${this.tabClass} ${isActive ? 'nuxt-link-active' : ''}`
    },
    checkActive (menu) {
      return this.getTabClass(menu).includes('nuxt-link-active')
    }
  }
}
</script>

<style lang="scss">
@import '../../lib/design-token/config-layout.scss';

$primary-color-background : #FFEBEB;
$primary-color-border: #FFBDC0;
.tab-menu {
  ul {
    position: relative;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    @at-root .mobile & {
      overflow-x: auto;
    }

    li {
      position: relative;
      padding: 0;
      margin-right: 30px;

      a {
        position: relative;
        display: inline-block;
        padding: 15px 0 12px 0;
        text-transform: uppercase;
        font-weight: bold;
        border-bottom-style: solid;
        border-bottom-width: 3px;
        border-bottom-color: transparent;

        .tab-badge {
          display: inline-block;
          margin-left: 5px;
        }
      }
    }
  }

  &.card {
    border-bottom: 1px solid #e0e0e0;
    ul li {
      margin: 0px;
      a {// tab all case
        padding: 13px 28px;
        border-radius: 12px 12px 0 0;
        background-color: $color-cool-grey-50;
        text-transform: unset;
      }
      a.nuxt-link-active { //tab when active
        padding-top: 13px;
        padding-bottom: 13px;
        background-color: $primary-color-background;
      }
    }
  }

  &.line {
    background-color: white;
    border: 1px solid #E0E0E0 !important;
    border-radius: 16px;
    padding: 0 32px;

    ul li a {
      text-transform: capitalize;
    }
  }

  &.pill {
    ul > li {
      margin-right: 16px;

      a {
        @extend .tabbar-secondary;

        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 20px;
        height: 42px;
        border-radius: $border-radius-pill;
        border: 1px solid;
        cursor: pointer;
        transition-duration: 0.3s;
        text-transform: capitalize;
      }
    }
  }

  &.none {
    ul {
      -ms-overflow-style: none;  /* Internet Explorer 10+ */
      scrollbar-width: none;  /* Firefox */
      &::-webkit-scrollbar {
        display: none;  /* Safari and Chrome */
      }
    }
  }

  .nuxt-link-active {
    cursor: default;
  }
}
</style>
